export default "__VITE_ASSET__DPEmITFQ__"